import { Globe2, Plus, RotateCw } from "lucide-react";
import { MetricStrip } from "../ui/MetricStrip";
import { marketingDashboardFixture } from "./marketingDashboardFixture";
import { PreviewServerCard } from "./PreviewServerCard";
import { PreviewSidebar } from "./PreviewSidebar";

/**
 * Presentational embedded console preview for the homepage. This is
 * marketing artwork with fictional data — not the authenticated console —
 * so the whole block is hidden from assistive technology.
 */
export function DashboardPreview() {
  return (
    <div className="dashboard-preview" aria-hidden="true">
      <PreviewSidebar />
      <div className="dashboard-preview-main">
        <div className="dashboard-preview-head">
          <div>
            <h2>Overview</h2>
            <p>Deploy, monitor, and scale your realtime infrastructure.</p>
          </div>
          <div className="dashboard-preview-head-actions">
            <span className="btn btn--ghost btn--sm">
              <Plus size={14} strokeWidth={1.7} absoluteStrokeWidth />
              New server
            </span>
            <span className="btn btn--ghost btn--sm">Last 24h</span>
            <span className="preview-icon-btn">
              <RotateCw size={16} strokeWidth={1.6} absoluteStrokeWidth />
            </span>
          </div>
        </div>

        <div className="dashboard-preview-grid">
          {marketingDashboardFixture.servers.map((server) => (
            <PreviewServerCard key={server.id} server={server} />
          ))}
        </div>

        <div className="dashboard-preview-footer">
          <MetricStrip items={marketingDashboardFixture.aggregate} />
          <span className="btn btn--ghost btn--sm">
            <Globe2 size={14} strokeWidth={1.7} absoluteStrokeWidth />
            View network
          </span>
        </div>
      </div>
    </div>
  );
}
